import { CollapsibleContentCard, Status } from '@indigo-ag/component-module';
import { FeedbackVariants } from '@indigo-ag/component-module/dist/commonjs/shared/theme/theme-helpers/feedback';
import { BackgroundCheck } from '@indigo-ag/schema';
import i18next from 'i18next';
import React from 'react';
import { LoadingIndicator } from 'shared';
import styled from 'styled-components';

import { getCheckStatusTranslation, getCheckStatusVariant } from '../../utils/backgroundCheck.util';
import { BackgroundCheckStepCard } from './BackgroundCheckStepCard';

const StyledStepsContainer = styled.div`
  column-gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

interface Props {
  backgroundCheck?: BackgroundCheck;
  loading?: boolean;
  readOnly?: boolean;
  title: string;
}

export const ContactBackgroundCheck = ({ backgroundCheck, loading, readOnly, title }: Props) => {
  const getCardContents = () => {
    if (loading) {
      return <LoadingIndicator />;
    }

    if (!backgroundCheck) {
      return i18next.t('backgroundCheck_notAvailable');
    }

    return (
      <StyledStepsContainer>
        {backgroundCheck.steps.map(step => (
          <BackgroundCheckStepCard key={step.id} backgroundCheckStep={step} readOnly={readOnly} />
        ))}
      </StyledStepsContainer>
    );
  };

  const statusVariant = getCheckStatusVariant(backgroundCheck?.displayStatus);

  return (
    <CollapsibleContentCard
      titleText={title}
      renderAfterTitle={() =>
        backgroundCheck ? (
          <Status
            label={getCheckStatusTranslation(backgroundCheck.displayStatus)}
            variant={statusVariant as FeedbackVariants}
          />
        ) : null
      }
    >
      {getCardContents()}
    </CollapsibleContentCard>
  );
};
